import { View, ViewOpts } from '@play-co/timestep-core/ui';
import { Match2RewardItem } from '../components/Match2RewardItem';
import { magicLampsGetRewardFromItem } from 'src/replicant/match2/magiclamps/magiclamps.getters';
import { MagicLampsRewardId } from 'src/replicant/match2/magiclamps/magiclamps.ruleset';

export type MagicLampsRewardIconParams = {
  type: MagicLampsRewardId;
  value: number;
  scale?: number;
};

export class MagicLampsRewardIcon extends View {
  public readonly icon: Match2RewardItem;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      width: 100,
      height: 100,
    });

    this.icon = new Match2RewardItem({
      superview: this,
      centerOnOrigin: true,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      prefix: 'x',
    });
  }

  public setup(params: MagicLampsRewardIconParams) {
    const reward = magicLampsGetRewardFromItem(params.type, params.value);
    if (reward) this.icon.setReward(reward);
    this.icon.style.scale = params.scale ?? 1;
  }

  /**
   * Somehow the text goes blank when changing the superview by normal means.
   * This is a workaround to ensure that the text shows up as before.
   */
  public reparent(parent: View) {
    const text = this.icon['countText'].text;
    this.icon['countText'].localeText = () => '';
    this.removeFromSuperview();
    this.updateOpts({ superview: parent });
    this.icon['countText'].updateOpts({ superview: this.icon });
    this.icon['countText'].text = text;
  }
}
